import React from 'react'
import PropTypes from 'prop-types'

const ModalFooter = ({align, children}) => {
  return (
    <div className={`modal__footer modal__footer--${align}`}>
      {children}
    </div>
  )
}

ModalFooter.propTypes = {
  align: PropTypes.oneOf(['center', 'left', 'right']),
  children: PropTypes.node
}

ModalFooter.defaultProps = {
  align: 'left'
}

export default ModalFooter



// WEBPACK FOOTER //
// ./src/components/Modal/footer.js